<div class="ml-2 flex h-16 flex-row">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <div
      tp="The value can be set using the metrics time filter (at the top of this page)"
      [tpIsEnabled]="fractionControl.isMetricsDate === true"
    >
      <div
        class="mb-5 flex cursor-pointer flex-row items-center"
        (click)="toggleSwitch()"
      >
        <div
          *ngIf="!!fractionControl.label"
          class="text-s1 mr-5 flex h-9 flex-shrink-0 select-none items-center text-base"
          >{{ fractionControl.label }}</div
        >

        <ui-switch
          [checked]="fractionControl.value"
          [disabled]="
            isDisabled === true || fractionControl.isMetricsDate === true
          "
          color="#64BD63"
        ></ui-switch>
      </div>
    </div>
  </div>
</div>
